const languageData = [
    {
        languageId: 'french',
        locale: 'fr',
        name: 'French',
        icon: 'fr'
    },
    {
        languageId: 'english',
        locale: 'en',
        name: 'English',
        icon: 'us'
    }
];
export default languageData;



// WEBPACK FOOTER //
// ./components/LanguageSwitcher/data.js